// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radioBtnsLabel__UDHk4 {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--inputs-default-text);
  display: block;
  margin-bottom: 8px;
  padding-right: 17px;
}

.radioBtnsWrapper__86Bv1 {
  display: flex;
}

.directionColumn__AOIb9 {
  flex-direction: column;
}

.radioItem__LGssT {
  display: flex;
  align-items: center;
  column-gap: 11px;
  margin-top: 2px;
  padding: 12px 11px;
  border-radius: 5px;
}
@media (max-width: 850px) {
  .radioItem__LGssT {
    padding-top: 7px;
    padding-bottom: 7px;
  }
}

.radioItemSmall__SIadr {
  padding: 4px 11px 4px 0px;
}

.radioItemFull__Am3Fy {
  width: 100%;
}

.radioItemDisabled__d0EJA {
  pointer-events: none;
}
.radioItemDisabled__d0EJA .itemIcon__BZ2fb {
  border-color: var(--selection-controls-radio-surface-disable);
}
.radioItemDisabled__d0EJA .labelText__wr7gb {
  color: var(--selection-controls-radio-text-disable);
}

.itemBtn__fKsi9 {
  width: 13px;
  height: 13px;
}

.itemInput__Xb7_H {
  margin: 0;
  display: none;
}

.itemIcon__BZ2fb {
  width: 13.5px;
  height: 13.5px;
  display: block;
  border: 1px solid var(--selection-controls-radio-surface-default);
  border-radius: 100%;
}

.itemChecked__aFZff {
  position: relative;
  border-color: var(--selection-controls-radio-surface-default);
}
.itemChecked__aFZff::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  width: 7.5px;
  height: 7.5px;
  background-color: var(--selection-controls-radio-surface-default);
  border-radius: 100%;
}

.labelText__wr7gb {
  font-size: 12px;
  line-height: 20px;
  color: var(--selection-controls-radio-text);
}

.labelItemChecked__Mpgjb {
  font-weight: 700;
}

.helperText__azIf5 {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__azIf5 {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.required__Ddl2H::after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./../src/components/form/RadioButtonsGroup/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,aAAA;AAzEF;;AA4EA;EACE,sBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAzEF;AA2EE;EARF;IASI,gBAAA;IACA,mBAAA;EAxEF;AACF;;AA2EA;EACE,yBAAA;AAxEF;;AA2EA;EACE,WAAA;AAxEF;;AA2EA;EACE,oBAAA;AAxEF;AA0EE;EACE,6DAAA;AAxEJ;AA2EE;EACE,mDAAA;AAzEJ;;AA6EA;EACE,WAAA;EACA,YAAA;AA1EF;;AA6EA;EACE,SAAA;EACA,aAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,cAAA;EACA,cAAA;EACA,iEAAA;EACA,mBAAA;AA1EF;;AA6EA;EACE,kBAAA;EACA,6DAAA;AA1EF;AA4EE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,iEAAA;EACA,mBAAA;AA1EJ;;AA8EA;EACE,eAAA;EACA,iBAAA;EACA,2CAAA;AA3EF;;AA8EA;EACE,gBAAA;AA3EF;;AA8EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AA3EF;AA6EE;EARF;IASI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EA1EF;AACF;;AA6EA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.radioBtnsLabel {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--inputs-default-text);\n  display: block;\n  margin-bottom: 8px;\n  padding-right: 17px;\n}\n\n.radioBtnsWrapper {\n  display: flex;\n}\n\n.directionColumn {\n  flex-direction: column;\n}\n\n.radioItem {\n  display: flex;\n  align-items: center;\n  column-gap: 11px;\n  margin-top: 2px;\n  padding: 12px 11px;\n  border-radius: 5px;\n\n  @media (max-width: 850px) {\n    padding-top: 7px;\n    padding-bottom: 7px;\n  }\n}\n\n.radioItemSmall {\n  padding: 4px 11px 4px 0px;\n}\n\n.radioItemFull {\n  width: 100%;\n}\n\n.radioItemDisabled {\n  pointer-events: none;\n\n  .itemIcon {\n    border-color: var(--selection-controls-radio-surface-disable);\n  }\n\n  .labelText {\n    color: var(--selection-controls-radio-text-disable);\n  }\n}\n\n.itemBtn {\n  width: 13px;\n  height: 13px;\n}\n\n.itemInput {\n  margin: 0;\n  display: none;\n}\n\n.itemIcon {\n  width: 13.5px;\n  height: 13.5px;\n  display: block;\n  border: 1px solid var(--selection-controls-radio-surface-default);\n  border-radius: 100%;\n}\n\n.itemChecked {\n  position: relative;\n  border-color: var(--selection-controls-radio-surface-default);\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: inline-block;\n    width: 7.5px;\n    height: 7.5px;\n    background-color: var(--selection-controls-radio-surface-default);\n    border-radius: 100%;\n  }\n}\n\n.labelText {\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--selection-controls-radio-text);\n}\n\n.labelItemChecked {\n  font-weight: 700;\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.required::after {\n  content: '*';\n  font-size: 10px;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioBtnsLabel": `radioBtnsLabel__UDHk4`,
	"radioBtnsWrapper": `radioBtnsWrapper__86Bv1`,
	"directionColumn": `directionColumn__AOIb9`,
	"radioItem": `radioItem__LGssT`,
	"radioItemSmall": `radioItemSmall__SIadr`,
	"radioItemFull": `radioItemFull__Am3Fy`,
	"radioItemDisabled": `radioItemDisabled__d0EJA`,
	"itemIcon": `itemIcon__BZ2fb`,
	"labelText": `labelText__wr7gb`,
	"itemBtn": `itemBtn__fKsi9`,
	"itemInput": `itemInput__Xb7_H`,
	"itemChecked": `itemChecked__aFZff`,
	"labelItemChecked": `labelItemChecked__Mpgjb`,
	"helperText": `helperText__azIf5`,
	"required": `required__Ddl2H`
};
module.exports = ___CSS_LOADER_EXPORT___;
